<template>
    <div class="custom-cascader el-cascader" :style="{minWidth: filterable ? '300px' : '250px'}">
        <el-popover
            placement="bottom"
            trigger="click"
            v-model="panelDisplay"
            @hide="search = ''"
            @show="setFocus"
            popper-class="p-0 custom-cascader-popover__popper">
            <el-cascader-panel 
                v-if="!filtering"
                @change="update"
                v-model="selectedValues"
                :options="options"
                :props="props">
                <template slot-scope="{ node, data }">
                    <div @click="cascaderClick(node, data)">{{ data.label }}</div> 
                </template> 
            </el-cascader-panel>
            <div v-else class="cascader-suggestion">
                <ul class="py-2 m-0">
                    <li 
                        v-for="suggestion in suggestions" 
                        :key="suggestion.value"
                        @click="updateSuggestion(suggestion.value)" >
                        <div 
                            class="suggestion-item cpointer prelative wp-10"
                            :class="[isChecked(suggestion.value) ? 'blue semibold' : '']">
                            <span class="suggestion-item-label">{{ suggestion.label }}</span>
                            <i v-if="isChecked(suggestion.value)" class="fright el-icon-check primary-50 semibold"/>
                        </div>
                    </li>
                </ul>
            </div>
            <template slot="reference">
                <div class="cascader-input el-input el-input--suffix">
                    <input type="text" readonly="readonly" class="el-input__inner"/>
                    <span class="el-input__suffix">
                        <span class="el-input__suffix-inner">
                            <i class="el-input__icon el-icon-arrow-up" :class="{'is-reverse' : panelDisplay}"></i>
                        </span>
                    </span>
                    <div class="cascader-items">
                        <div class="item p-1" v-if="previewItems.length > 0">
                            <!-- <img class="item-img" :src="previewItems[0].img"/> -->
                            <span class="item-txt pl-2">{{previewItems[0].label}}</span>
                        </div>
                        <div class="item p-1" v-if="previewItems.length > 1">
                            <span class="item-tag">+{{previewItems.length - 1}}</span>
                        </div>
                        <div class="item-search ml-1" v-if="filterable">
                            <input type="text" ref="search" v-model="search" @input="filterOptions" @focus="forceOpenPanel" class="b-0"/>
                        </div>
                        <div v-if="placeholder != '' && previewItems.length == 0" class="cascader-placeholder">
                            <span>{{ placeholder }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </el-popover>
    </div>
</template>

<script>
// Example : Options
// [
//     {
//         value: 1,
//         label: 'Commercial',
//         children: [
//             {
//                 value: 2,
//                 label: 'Caroline qsd dsg dfg qfg dfg sdfg sdf ',
//                 img: 'http://file.lan/?id=JUQ4RiVEQm0lMTIyJUNGJUVFJTlEJUNGJThBJUJEJUMwJUVCJThBJUI5JTA5JUQ1JUQzJUUzJUVGJTJBJTE0UyVFNTEyZ3MyJUIzJTlCZiVCMiUxMSUzQiVDRiVBOCUwQSVEQiVERVVhJUUyJTFCJTgwJTIxJTFEJUIxYm4lQUIlMUQlQjklQjJCJUQ1JTA3JTIxJUE0JTk0JUEycyU5MyUyMkpBbyUxRiUyQSVDQ1dzJTdGJTYwJTg5JUMxUSVEQSVGNCVDOCUxNW8lN0YlN0YlRDglOUUlQjklOUElREIlOUI4eSVFMiU4RiVBOA=='
//             }, 
//             {
//                 value: 3,
//                 label: 'Jérome',
//                 img: 'https://lh3.googleusercontent.com/proxy/RkLCRTBjaMFQBvD8wiQyudk5c0IPvQ1lzPaN2WQ8ApAoei6nlAMzYP55gcd1YDS3c1tao-qsfuzUhae70DIwYcx0JMMjOHFsg07xcQl-rIeNU4bRCuXMoLgunwcx'
//             }, 
//             {
//                 value: 4,
//                 label: 'Corentin',
//                 img: 'https://image.shutterstock.com/image-vector/indifferent-man-avatar-web-button-600w-511321135.jpg'
//             }
//         ]
//     }, 
// ]
    export default {
        props: {
            value: {
                type: [Array, Number],
                required: true
            },
            options: {
                type: Array,
                required: true,
                default: () => []
            },
            filterable: {
                type: Boolean,
                required: false,
                default: false
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            multiple: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data(){
            return {
                search: '',
                panelDisplay: false,
                suggestions: [],
                props: {
                    multiple: this.multiple, 
                    expandTrigger: 'hover',
                    emitPath: false
                },
                selectedValues: this.value
            }
        },
        watch: {
            value(newVal) {
                this.selectedValues = newVal;
            }
        },
        computed: {
            filtering(){
                return this.search != ''
            },
            previewItems(){
                let previewItems = []
                this.options.map(group =>{
                    group.children.map(child => {
                        if(this.multiple){
                            if(this.isChecked(child.value)){
                                previewItems.push(child)
                            }
                        } else{
                            if(this.value == child.value){
                                previewItems.push(child)
                            }
                        }
                    })
                })
                return previewItems
            },
        },
        methods: {
            isChecked(value){
                return this.multiple ? this.selectedValues.flat().includes(value) : this.selectedValues === parseInt(value)
            },
            filterOptions(){
                this.suggestions = []
                if(this.filtering){
                    this.options.map(group =>{
                        let childs = group.children.filter(child => child.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").indexOf(this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")) > -1)
                        childs.map(child => {
                            this.suggestions.push(child)
                        })
                    })
                } else{
                    this.suggestions = this.options
                }
                this.$forceUpdate()
            },
            forceOpenPanel(){
                setTimeout(() => {
                    this.panelDisplay = true
                }, 100)
            },
            updateSuggestion(value){
                if(!this.multiple){
                    this.update([])
                }
                if(!this.isChecked(value)){
                    this.multiple ? this.update([...this.selectedValues, ...[value]]) : this.update(value)
                } else{
                    this.multiple ? this.update(this.selectedValues.filter(val => val != value)) : this.update([])
                }
            },
            update(value){
                this.$emit('input', value);
            },
            cascaderClick(node, data){ 
                let val = []; 
                if(this.multiple){
                    if(this.selectedValues.flat().includes(node.value)){
                        let valueTmp = [...this.selectedValues];
                        if(!_.isNil(data.children)) {
                            valueTmp = [];
                        } else {
                            valueTmp.splice(valueTmp.findIndex(item => item == node.value), 1)
                        }

                        this.selectedValues = valueTmp;
                        this.update(this.selectedValues);
                    } else if(node.hasChildren && node.checked) {
                        data.children.forEach(child => {
                            this.selectedValues = this.selectedValues.filter(value => value !== child.value);
                        });
                        this.update(this.selectedValues);
                    } else {
                        if(!_.isNil(data.children)) {
                            data.children.forEach(subChoice => val.push(subChoice.value));
                        } else {
                            val.push(node.value); 
                        }

                        this.selectedValues = [...this.selectedValues, ...val];
                        this.update(this.selectedValues);
                    }
                } else{
                    this.selectedValues = node.path;
                    this.update(node.value)
                }
            },
            setFocus(){
                this.$refs.search ? this.$refs.search.focus() : false
            }
        }
    }
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';
.custom-cascader.el-cascader {
    .cascader-items{
        position: absolute;
        left: 0;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        line-height: normal;
        text-align: left;
        box-sizing: border-box;
        .item{
            display: inline-flex;
            align-items: center;
            .item-img{
                width: 20px;
                height: 20px;
                @include border-radius(4px);
            }
            .item-txt{
                display: inline-block;
                max-width: 150px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            .item-tag{
                background-color: $lightgrey;
                font-weight: $font-weight-semibold;
                @include border-radius(4px);
                padding: 0 4px;
            }
        }
        .item-search{
            align-items: center;
            display: flex;
            width: 50px;
        }
        .cascader-placeholder {
            padding-left: 12px;
            color: $gray-100;
        }
    }
    .el-input__icon.el-icon-arrow-up {
        color: $gray-100;
        transform: rotate(180deg);
        &.is-reverse {
            transform: rotate(0deg);
        }
    }
    .el-input__suffix {
        right: 6px;
    }
}
.cascader-suggestion {
    min-width: 250px;
    ul{
        li{
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 34px;
            padding: 0 16px;
            text-align: left;
            outline: none;
            cursor: pointer;
            &:hover{
                background-color: $gray-0;
            }
            .suggestion-item{
                .suggestion-item-label{
                    max-width: 350px;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    padding-right: 4px;
                }
                i{
                    line-height: 1.4;
                }
            }
        }
    }
}
// Cascader popper element
.custom-cascader-popover__popper {
    .el-cascader-node {
        padding-left : 12px;
        padding-right: spacer(5);
        height       : 32px;
        line-height  : 32px;
    }
    .el-cascader-menu {
        color: $gray-100;
    }
    .el-cascader-menu:last-child .el-cascader-node {
        padding-right: 12px;
        &.is-active {
        //    background: $primary-05; 
        }
    }
    .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
        color: $primary-50;
        font-weight: $font-weight-regular;
    }
    .el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover {
        background: $primary-05;
        font-weight: $font-weight-regular;
    }
    .el-cascader-node__label {
        padding: 0 spacer(2);
    }
    .el-cascader-node__postfix {
        right: 12px;
        color: $gray-60;
    }
}
</style>